import Header from './view'

/* placeholder for container code */

export default Header
